import { i as initialize } from './ionic-global-286e724e.js';

const globalScripts = initialize;

export { globalScripts as g };
